import { Link } from "react-router-dom";
import { ArrowRight, Megaphone } from "lucide-react";
import { FEATURED_BRIEFING, briefingPath } from "@/data/featuredBriefing";

// Fixed alert strip that sits directly beneath the main navigation on the
// homepage. Reusable & config-driven: update `featuredBriefing.js` each week.
export const AnnouncementBar = () => {
  if (!FEATURED_BRIEFING.active) return null;

  return (
    <Link
      to={briefingPath()}
      data-testid="homepage-announcement-bar"
      aria-label="Read the latest legal briefing"
      className="announcement-bar group fixed left-0 w-full z-40 top-20 bg-forest text-canvas border-b border-gold/40 shadow-[0_2px_10px_rgba(0,0,0,0.25)]"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-12 h-12 md:h-11 flex items-center gap-3 md:gap-5">
        <span className="announcement-bar__pulse hidden sm:inline-flex items-center gap-1.5 shrink-0 font-sans text-[10px] md:text-[11px] tracking-[0.18em] uppercase font-bold text-charcoal bg-gold px-2.5 py-1">
          <Megaphone className="w-3.5 h-3.5" strokeWidth={2} />
          New Legal Alert
        </span>
        <p className="flex-1 min-w-0 truncate font-sans text-[12px] md:text-[13px] tracking-[0.01em] text-canvas/90">
          <span className="sm:hidden font-bold text-gold">NEW LEGAL ALERT — </span>
          {FEATURED_BRIEFING.alertText}
        </p>
        <span
          data-testid="homepage-announcement-button"
          className="shrink-0 inline-flex items-center gap-1.5 font-sans text-[10px] md:text-[11px] tracking-[0.14em] uppercase font-bold text-charcoal bg-canvas px-3 md:px-4 py-1.5 border border-canvas transition-colors duration-300 group-hover:bg-gold group-hover:border-gold"
        >
          <span className="hidden md:inline">Read the Briefing</span>
          <span className="md:hidden">Read</span>
          <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5" strokeWidth={2} />
        </span>
      </div>
    </Link>
  );
};
